import React, { useState, useEffect } from 'react';
import styles from './progress-bar.module.scss';

const ProgressBar = ({
  percentValue, 
  labelText, 
  type, 
  maxValue = 100, 
  barColor, 
  height,
  animated = true,
  variant = 'standard' // 'standard', 'negative', or 'simple'
}) => {

  const [percent, setPercent] = useState(animated ? 0 : Math.abs(percentValue));

  useEffect(() => {
    if (animated) {
      requestAnimationFrame(() => {
        setPercent(Math.abs(percentValue));
      });
    }
  }, [percentValue, animated]);

  // Determine bar color based on variant
  const getBarColor = () => {
    if (barColor) return barColor;
    if (variant === 'negative') return 'var(--color-app-henley-blue)';
    return '#405363'; // default color
  };

  return (
    <div className={styles.progressBarContainer}>
      <div 
        className={`${styles.progressBar} ${type === "left" ? styles.directionLeft: ""} ${maxValue > 100 ? styles.progressBarWithMaxValue : ""}`}
        style={height ? { height: `${height}px` } : {}}
      >
        {percentValue !== 0 &&(
          <div 
              className={styles.progress} 
              style={{ 
                width: `${percent}%`, 
                backgroundColor: getBarColor() 
              }}
          >  
          </div>
        )}
        {maxValue > 100 && (
            <div className={styles.valueBorder} style={{left: 100/maxValue * 100 + '%'}}></div>
        )}
      </div>
      {labelText && (
          <span className={styles.labelText}>{labelText}</span>
      )}
    </div>
  );
}

export default ProgressBar;